var dependencies1 = [
    'ngAnimate',
    'ngMaterial',
    'ngMessages',
    'ngRoute',
    'ngCookies',
    'impactx.z', /* Für den Angular-Upgrade */
    'impactx.MenuDirectives',
    'impactx.account',
    'impactx.accountassignmenttype',
    'impactx.address',
    'impactx.approval',
    'impactx.approvalincomplete',
    'impactx.autoComplete',
    'impactx.backImg',
    'impactx.bank',
    'impactx.basket',
    'impactx.basketAmount',
    'impactx.budget',
    'impactx.cancelcondition',
    'impactx.cancellation',
    'impactx.changeauthorization',
    'impactx.classificationmaterialgroup',
    'impactx.catalog',
    'impactx.comments',
    'impactx.contentdashboard',
    'impactx.controlChip',
    'impactx.controlstructure',
    'impactx.cscontract',
    'impactx.deliverynote',
    'impactx.demand',
    'impactx.disposition',
    'impactx.download',
    'impactx.downloadbutton',
    'impactx.favorites',
    'impactx.imageUpload',
    'impactx.includeReplace',
    'impactx.item',
    'impactx.listcache',
    'impactx.lobby',
    'impactx.lot',
    'impactx.awdtext',
    'impactx.manufacturer',
    'impactx.moneyInput',
    'impactx.monitordashboard',
    'impactx.multimedia',
    'impactx.navigation',
    'impactx.numberInput',
    'impactx.panel',
    'impactx.percentage',
    'impactx.prg2ctt',
    'impactx.productcomparison',
    'impactx.productlist',
    'impactx.profile',
    'impactx.purchaseorder',
    'impactx.purchaserequest',
    'impactx.relationView',
    'impactx.requestItem',
    'impactx.sapconfig',
    'impactx.search',
    'impactx.selectionDialog',
    'impactx.statusicon',
    'impactx.swimLane',
    'impactx.tender',
    'impactx.timeline',
    'impactx.transcludeReplace',
    'impactx.userdialog',
    'impactx.userlist',
    'impactx.usergroups',
    'impactx.userctu',
    'impactx.vendor',
    'impactx.version',
    'nvd3',
    'smart-table',
    'ui-rangeSlider',
    'impactx.product',
    'ui-rangeSlider',
    'angular-loading-bar',
    'ui.tinymce',
    'impactx.disposition',
    'impactx.scheduler',
    'impactx.datepicker',
    'impactx.printbutton',
    'impactx.login',
    'impactx.ghostloginapproval',
    'impactx.printbutton',
    'impactx.dashboard',
    'impactx.tagcloud',
    'impactx.menubutton',
    'impactx.toolbar',
    'impactx.sidebar',
    'impactx.scrollMenu',
    'impactx.displayelements',
    'impactx.vcatalog',
    'impactx.company',
    'impactx.condition',
    'impactx.supplier',
    'impactx.orderconfirmation',
    'impactx.deliveryadvice',
    'impactx.deliverycomplaint',
    'impactx.user',
    'impactx.warnings',
    'impactx.suppliercatalogupload',
    'impactx.dropzone',
    'impactx.quota',
    'impactx.attachments',
    'impactx.confirmation',
    'impactx.redirectandsave',
    'impactx.message',
    'impactx.pushmessage',
    'impactx.redirectandsave',
    'impactx.orderprocess',
    'impactx.delegation',
    'impactx.validationbutton',
    'impactx.invoice',
    'impactx.supplierbaskettemplate'
];

    
var dependencies2 = [
    'impactx.toast',
    'impactx.colorUtil',
    'impactx.supplierbasket',
    'impactx.admindashboard',
    'impactx.orderconfiguration',
    'impactx.complaintconfiguration',
    'impactx.reLoginExternal',
    'impactx.util',
    'impactx.productview',
    'impactx.demandbundle',
    'impactx.retoure',
    'impactx.beco',
    'impactx.livereport',
    'impactx.numberingscheme',
    'impactx.fileselect',
    'impactx.hierarchyselect',
    'impactx.formutil',
    'impactx.themeworld',
    'impactx.logouttimer',
    'impactx.analytics',
    'impactx.rfq',
    'impactx.cscaccounting',
    'angulartics',
    'angulartics.piwik',
    'impactx.osu',
    'impactx.ruleset',
    'impactx.saperrormessage',
    'impactx.rfx',
    'impactx.rfxsupplier',
    'impactx.system',
    'impactx.filehelper',
    'impactx.fallbackstartpage',
    'impactx.configuration',
    'impactx.passwordrecovery',
    'impactx.indexqueue',
    'ngWebSocket',
    'ui.sortable',
    'impactx.passwordrecovery',
    'ngMaterialDateRangePicker',
    'impactx.filebrowser',
    'impactx.uploadservicebrowser',
    'impactx.contentservicebrowser',
    'impactx.legallinking',
    'impactx.polling',
    'impactx.catalogruleresult',
    'impactx.dialog',
    'impactx.securitydata',
    'impactx.attributes',
    'impactx.smartform',
    'gridster',
    'impactx.checkboxgroup',
    'impactx.togglebutton',
    'impactx.compilationarticle',
    'impactx.productstock',
    'impactx.electronicdownload',
    'impactx.opengovernmentdata',
    'impactx.excelimportbaskets',
    'impactx.autocompletegroup',
    'impactx.themeconfigurator',
    'impactx.autocompleteselection',
    'impactx.websocket',
    'impactx.landingpage',
    'impactx.copyToClipBoard',
    'impactx.shareLink',
    'impactx.datedisplay',
    'sun.scrollable',
    'impactx.input',
    'impactx.treeselect',
    'impactx.event',
    'impactx.workspace',
    'impactx.chiplist',
    'angular-bind-html-compile',
    'impactx.customerservice',
    'impactx.sso',
    'impactx.imagezoom',
    'impactx.stockwithdrawal',
    'impactx.productlabel',
    'impactx.help',
    'impactx.combibudget',
    'impactx.manualordercreation',
    'impactx.statistic',
    'impactx.companyhierarchy',
    'impactx.greetingcard',
    'md.time.picker',
    'impactx.clientcompany',
    'impactx.cxml',
    'impactx.oci',
    'impactx.tinymce',
    'impactx.subsequentpurchaseorderdata',
    'impactx.productcoding',
    'impactx.productgroup',
    'impactx.tax',
    'impactx.b2b',
    'impactx.deliveryinfo',
    'impactx.ownsecurityroles',
    'impactx.filter',
    'impactx.inputsettings',
    'impactx.calendar',
    'impactx.localization',
    'impactx.orderlimit',
    'impactx.communicationconfig',
    'impactx.restproduct',
    'impactx.awarddecision'
];

var dependencies = dependencies1.slice();

dependencies = dependencies.concat(dependencies2);

// Declare app level module which depends on views, and modules
var mainAppModule = angular.module('impactx', dependencies).config([
    '$routeProvider', '$mdAriaProvider', '$sceDelegateProvider', 
    '$locationProvider', '$provide', 'cfpLoadingBarProvider',
    function ($routeProvider, $mdAriaProvider, $sceDelegateProvider, 
        $locationProvider, $provide, cfpLoadingBarProvider) {
        $sceDelegateProvider.resourceUrlWhitelist(['**']);
        $locationProvider.hashPrefix('');

        $routeProvider.otherwise({
            redirectTo: '/fallbackstartpage'
        });
        $mdAriaProvider.disableWarnings();
        cfpLoadingBarProvider.includeBar = true;
        cfpLoadingBarProvider.includeSpinner = false;
        cfpLoadingBarProvider.parentSelector = '#page-loading-overlay';
        cfpLoadingBarProvider.latencyThreshold = 500;

        // this is the only way to avoid auto complete password to overlap with the floating label (only necessary for the password inputs)
        $provide.decorator('mdInputContainerDirective', function ($delegate, $interval, $mdTheming) {
            var directive = $delegate[0];

            directive.compile = function () {
                return {
                    post: function ($scope, element, attr, ctrl) {
                        $mdTheming(element);

                        var interval;
                        var count = 0;

                        if (ctrl && ctrl.input) {
                            interval = $interval(function () {
                                if (count > 10) {
                                    $interval.cancel(interval);
                                }

                                try {
                                    if (ctrl.input.parent()[0].querySelector('input:-webkit-autofill')) {
                                        ctrl.element.addClass('md-input-has-value');
                                        $interval.cancel(interval);
                                    }
                                } catch (e) {
                                    $interval.cancel(interval);
                                }

                                count++;
                            }, 25);
                        }
                    }
                };
            };

            return $delegate;
        });
    }
]);
angular.module('impactx').run(function ($rootScope, $securityManager, $config, $context, $redirect, $errorHandler,
                                        DeeplinkService, $location, AppConfiguration, $window, gridsterConfig, SmartFormTemplateCache,
                                        AppcuesService, cfpLoadingBar, OpenIdService,
                                        WarningService, LoginService, TranslationService, sidebarShow) {
    setConfigData();

    $config.useSecureCookie = configData.useSecureCookie;
    gridsterConfig.resizable = SmartFormTemplateCache.getDefaultSmartFormGridsterConfig().resizable;
    objectFitImages();

    AppConfiguration.initialize().then(function () {
        initBasicPageData();
        AppcuesService.registerHandlers();
    });

    $rootScope.$on('$routeChangeStart', function (event, next, current) {
        $rootScope.previousRoute = current;
        if (!$rootScope.previousLocations) {
            $rootScope.previousLocations = [];
        }
        $rootScope.previousLocations.push($location.path());
        if ($rootScope.previousLocations.length > 1) {
            $rootScope.previousLocation = $rootScope.previousLocations.shift();
        }
        if (cfpLoadingBar.status() > 0) {
            cfpLoadingBar.complete();
        }
        if (!$securityManager.isAuthorized() && !next.noSecurity) {
            var idTokenGiven = !next.$$route && $window.location.hash && $window.location.hash.indexOf("id_token") > 0;
            var errorGiven = !next.$$route && $window.location.hash && $window.location.hash.indexOf("error") > 0;
            if (!idTokenGiven && !errorGiven) {
                DeeplinkService.storeDeeplink($location.$$path);
            }
            var externalLink = AppConfiguration.get('externalAuthBBGPortalImpactX');
            var hasMultipleExternalAuthorizations = AppConfiguration.get('hasMultipleExternalAuthorizations');

            var goTo;
            if (next.params.value) {
                goTo = $config.customLoginRoute + '/' + next.params.value;
            }
            else if (idTokenGiven) {
                console.log("given hash: " + $window.location.hash);
                OpenIdService.setLastOpenIdParams(getQueryParams($window.location.hash.substring(2, $window.location.hash.length)));
                goTo = "/loginopenid";
                if (DeeplinkService.getRecentOsuTan()) {
                    goTo += "/" + DeeplinkService.getRecentOsuTan();
                    DeeplinkService.deleteRecentOsuTan();
                }
            }
            else if (errorGiven) {
                var params = getQueryParams($window.location.hash.substring(2, $window.location.hash.length));
                goTo = "/login/error/" + params["error"] + "/" + params["error_description"];
            }
            else if (hasMultipleExternalAuthorizations) {
                var defaultOpenIdUrl = AppConfiguration.get('defaultOpenIdUrl');
                if (defaultOpenIdUrl) {
                    if (!$context.externalLinkCalled) {
                        $context.externalLinkCalled = true;
                        $window.location.href = defaultOpenIdUrl;
                    }
                }
                else {
                    goTo = "/chooseexternallogin";
                }
            }
            else if (externalLink) {
                if (!$context.externalLinkCalled) {
                    $context.externalLinkCalled = true;
                    $window.location.href = externalLink;
                }
            }
            else {
                goTo = $config.loginRoute;
            }

            // no logged user, we should be going to #login
            $redirect.redirectTo(null, goTo);
        }
        else if (next.process && !$securityManager.isProcessAllowed(next.process)) {
            // no logged user, we should be going to #login
            $errorHandler.showErrors([{
                error: 'Seite nicht erlaubt'
            }, {
                error: 'Page not allowed.'
            }]);
            event.preventDefault();
        }
        if ($context.needsDataInput()) {
            if (current.$$route.path === "/afterlogininput") {
                let hints = [];
                if ($context.neededDataInput.trns.fillOutHint) {
                    hints.push($context.neededDataInput.trns.fillOutHint);
                }
                if ($context.neededDataInput.trns.fillOutHintTermsOfUse) {
                    hints.push($context.neededDataInput.trns.fillOutHintTermsOfUse);
                }
                WarningService.showWarningDialog(angular.noop, null, TranslationService.get("warning"),
                    TranslationService.get("ok"), $context.neededDataInput.trns.abort, hints,
                    null, false,
                    function () {
                        sidebarShow.setToggleIsHidden(false);
                        LoginService.logout();
                    });
            }
            $redirect.redirectTo(null, "/afterlogininput");
        }
    });

    function getQueryParams(query) {
        var vars = query.split("&");
        var queryParams = {};
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            var key = decodeURIComponent(pair[0]);
            var value = decodeURIComponent(pair[1]);
            // If first entry with this name
            if (typeof queryParams[key] === "undefined") {
                queryParams[key] = decodeURIComponent(value);
                // If second entry with this name
            } else if (typeof queryParams[key] === "string") {
                queryParams[key] = [queryParams[key], decodeURIComponent(value)];
                // If third or later entry with this name
            } else {
                queryParams[key].push(decodeURIComponent(value));
            }
        }
        return queryParams;
    }

    function initBasicPageData() {
        $rootScope.pageTitle = AppConfiguration.get('pageTitle');
        $rootScope.pageFavIcon = AppConfiguration.get('pageFavIcon');
        $rootScope.previousLocations = [];
    }

    function setConfigData() {
        $rootScope.url = configData.url;
        $config.sourceURL = configData.url;
        $config.baseURL = configData.baseUrl;
        $config.tinymceOptions.baseURL = configData.baseUrl + "/external/tinymce";
        if (configData.loginRoute) {
            $config.loginRoute = '/' + configData.loginRoute;
        }
        else {
            $config.loginRoute = '/login';
        }

        if (configData.customLoginRoute) {
            $config.customLoginRoute = '/' + configData.customLoginRoute;
        }
        else {
            $config.customLoginRoute = '/custom';
        }
    }

    $rootScope.$watch(function () {
        return $location.path()
    }, function (newLocation, oldLocation) {
        //store the location. This is needed to detect if the back button is used.
        //If so, this will be called before the controller. So we can check in the controller
        //if location.path() !== $rootScope.location. If so, the back button has been used.
        $rootScope.location = newLocation;
    });
});

window.ixAppModuleFileLoaded = true;

